import React from 'react'
import { Box, Image, SxStyleProp } from 'rebass'
import { containerStyles, getImageStyles, getMobileImageStyles } from './BillboardImage.styles'

export enum MobileImageLocation {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}

export enum ModuleImagePositions {
  centerCenter,
  centerBottom,
}

export interface IBillboardImageProps {
  src: string
  alt: string
  mobileSrc?: string
  mobileImageLocation?: MobileImageLocation
  mobileFullWidth?: boolean
  position?: ModuleImagePositions
  isOverlapping?: boolean
  sx?: SxStyleProp
}

export const BillboardImage = ({
  src,
  mobileSrc,
  alt,
  position,
  isOverlapping,
  mobileFullWidth,
  sx,
}: IBillboardImageProps) => {
  const imagePosition = position === ModuleImagePositions.centerBottom ? 'end' : 'center'

  return (
    <Box
      sx={{
        ...containerStyles,
        alignSelf: isOverlapping ? [imagePosition, imagePosition, 'start'] : ['center', 'center', imagePosition],
        position: 'relative',
        width: mobileFullWidth ? ['100vw', '100vw', 'auto'] : 'auto',
        ...(isOverlapping ? { width: '50%' } : {}),
        ...sx,
      }}
    >
      <Image src={mobileSrc || src} alt={alt} sx={getMobileImageStyles(isOverlapping, mobileFullWidth)} />
      <Image src={src} alt={alt} sx={getImageStyles(isOverlapping)} />
    </Box>
  )
}
